import { workerClient } from './api/workerClient';
import { env } from '../config/env';

export const productService = {
    getProducts: async (params?: any) => {
        // Map params to API spec
        const queryParams = new URLSearchParams();

        if (params?.search) queryParams.append('q', params.search);
        if (params?.page) queryParams.append('page', params.page.toString());
        if (params?.size) queryParams.append('size', params.size.toString());
        if (params?.category) queryParams.append('category', params.category);
        if (params?.sort) queryParams.append('sort', params.sort);

        // Handle array for attributes
        if (params?.attributes) {
            if (Array.isArray(params.attributes)) {
                params.attributes.forEach((attr: string) => queryParams.append('attributes', attr));
            } else {
                queryParams.append('attributes', params.attributes);
            }
        }

        const response = await workerClient.get(`/search?${queryParams.toString()}`);
        return response.data.data;
    },

    getProduct: async (codeOrId: string) => {
        const response = await workerClient.get(`/products/${codeOrId}`);
        console.log('Product API response:', response.data);
        // API returns data wrapped in { data: product } structure
        return response.data.data || response.data;
    },

    searchProducts: async (query: string) => {
        const response = await workerClient.get('/search', { params: { q: query } });
        return response.data;
    },

    getProductByCodeFromCdn: async (productCode: string) => {
        const baseUrl = env.CDN_BASE_URL;
        const response = await fetch(`${baseUrl}${productCode}.json`);
        if (!response.ok) throw new Error('Product not found on CDN');
        return await response.json();
    }
};
